module.exports = __webpack_public_path__ + "media/student_lending_center/powered-by-a0a25e4b.png";